import { createContext } from 'react';

export const initialUser = { email: '' };

export const UserContext = createContext(null);
export const UserDispatchContext = createContext(null);

export const userReducer = (user, action) => {
    switch (action.type) {
        case 'ADD_USER': {
            return { ...user, email: action.email };
        }
        default: {
            throw Error('Unknown action: ' + action.type);
        }
    }
};
